import React, { createContext, useContext, useEffect, useRef, useMemo, isValidElement, useState } from "react";
import { createRoot } from "react-dom/client";
const NostoContext = createContext({
  account: "",
  currentVariation: "",
  pageType: "",
  responseMode: "HTML",
  clientScriptLoaded: false,
  useRenderCampaigns: () => void 0
});
function useNostoContext() {
  const context = useContext(NostoContext);
  if (!context) {
    throw new Error("No nosto context found");
  }
  return context;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
function Nosto404(props) {
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("404");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewNotFound().setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "notfound"
    })
  });
}
function NostoOther(props) {
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("other");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewOther().setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "other"
    })
  });
}
function NostoCheckout(props) {
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("checkout");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewCart().setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "cart"
    })
  });
}
function isPlainObject(value) {
  const isObject = (v) => String(v) === "[object Object]";
  if (!isObject(value))
    return false;
  const constructor = value.constructor;
  if (constructor === void 0)
    return true;
  const prototype = constructor.prototype;
  if (!isObject(prototype))
    return false;
  if (!prototype.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  return true;
}
function deepCompare(a, b) {
  if (a === b) {
    return true;
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((v, i) => deepCompare(v, b[i]));
  }
  if (isPlainObject(a) && isPlainObject(b)) {
    const entriesA = Object.entries(a);
    if (entriesA.length !== Object.keys(b).length) {
      return false;
    }
    return entriesA.every(([k2, v]) => deepCompare(v, b[k2]));
  }
  return false;
}
function useDeepCompareEffect(callback, dependencies) {
  return useEffect(callback, useDeepCompareMemoize(dependencies));
}
function useDeepCompareMemoize(value) {
  const ref = useRef(value);
  const signalRef = useRef(0);
  if (!deepCompare(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }
  return useMemo(() => ref.current, [signalRef.current]);
}
function NostoProduct(props) {
  const {
    product,
    tagging
  } = props;
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("product");
  useDeepCompareEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setResponseMode(responseMode).viewProduct(product).setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, product, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "product"
    }), /* @__PURE__ */ jsxs("div", {
      className: "nosto_product",
      style: {
        display: "none"
      },
      children: [(tagging == null ? void 0 : tagging.variationId) && /* @__PURE__ */ jsx("span", {
        className: "variation_id",
        children: tagging.variationId
      }), product && /* @__PURE__ */ jsx("span", {
        className: "product_id",
        children: product
      }), (tagging == null ? void 0 : tagging.name) && /* @__PURE__ */ jsx("span", {
        className: "name",
        children: tagging.name
      }), (tagging == null ? void 0 : tagging.url) && /* @__PURE__ */ jsx("span", {
        className: "url",
        children: tagging.url.toString()
      }), (tagging == null ? void 0 : tagging.imageUrl) && /* @__PURE__ */ jsx("span", {
        className: "image_url",
        children: tagging.imageUrl.toString()
      }), (tagging == null ? void 0 : tagging.availability) && /* @__PURE__ */ jsx("span", {
        className: "availability",
        children: tagging.availability
      }), (tagging == null ? void 0 : tagging.price) && /* @__PURE__ */ jsx("span", {
        className: "price",
        children: tagging.price
      }), (tagging == null ? void 0 : tagging.listPrice) && /* @__PURE__ */ jsx("span", {
        className: "list_price",
        children: tagging.listPrice
      }), (tagging == null ? void 0 : tagging.priceCurrencyCode) && /* @__PURE__ */ jsx("span", {
        className: "price_currency_code",
        children: tagging.priceCurrencyCode
      }), (tagging == null ? void 0 : tagging.brand) && /* @__PURE__ */ jsx("span", {
        className: "brand",
        children: tagging.brand
      }), (tagging == null ? void 0 : tagging.description) && /* @__PURE__ */ jsx("span", {
        className: "description",
        children: tagging.description
      }), (tagging == null ? void 0 : tagging.googleCategory) && /* @__PURE__ */ jsx("span", {
        className: "description",
        children: tagging.googleCategory
      }), (tagging == null ? void 0 : tagging.condition) && /* @__PURE__ */ jsx("span", {
        className: "condition",
        children: tagging.condition
      }), (tagging == null ? void 0 : tagging.gender) && /* @__PURE__ */ jsx("span", {
        className: "gender",
        children: tagging.gender
      }), (tagging == null ? void 0 : tagging.ageGroup) && /* @__PURE__ */ jsx("span", {
        className: "age_group",
        children: tagging.ageGroup
      }), (tagging == null ? void 0 : tagging.gtin) && /* @__PURE__ */ jsx("span", {
        className: "gtin",
        children: tagging.gtin
      }), (tagging == null ? void 0 : tagging.category) && (tagging == null ? void 0 : tagging.category.map((category, index) => /* @__PURE__ */ jsx("span", {
        className: "category",
        children: category
      }, index))), (tagging == null ? void 0 : tagging.tags1) && tagging.tags1.map((tag, index) => /* @__PURE__ */ jsx("span", {
        className: "tag1",
        children: tag
      }, index)), (tagging == null ? void 0 : tagging.tags2) && tagging.tags2.map((tag, index) => /* @__PURE__ */ jsx("span", {
        className: "tag2",
        children: tag
      }, index)), (tagging == null ? void 0 : tagging.tags3) && tagging.tags3.map((tag, index) => /* @__PURE__ */ jsx("span", {
        className: "tag3",
        children: tag
      }, index)), (tagging == null ? void 0 : tagging.ratingValue) && /* @__PURE__ */ jsx("span", {
        className: "rating_value",
        children: tagging.ratingValue
      }), (tagging == null ? void 0 : tagging.reviewCount) && /* @__PURE__ */ jsx("span", {
        className: "review_count",
        children: tagging.reviewCount
      }), (tagging == null ? void 0 : tagging.alternateImageUrls) && tagging.alternateImageUrls.map((url, index) => /* @__PURE__ */ jsx("span", {
        className: "alternate_image_url",
        children: url.toString()
      }, index)), (tagging == null ? void 0 : tagging.customFields) && Object.keys(tagging.customFields).map((field, index) => tagging.customFields && tagging.customFields[field] && /* @__PURE__ */ jsx("span", {
        className: field,
        children: tagging.customFields[field]
      }, index)), (tagging == null ? void 0 : tagging.skus) && tagging.skus.map((sku, index) => /* @__PURE__ */ jsxs("span", {
        className: "nosto_sku",
        children: [(sku == null ? void 0 : sku.id) && /* @__PURE__ */ jsx("span", {
          className: "product_id",
          children: sku.id
        }), (sku == null ? void 0 : sku.name) && /* @__PURE__ */ jsx("span", {
          className: "name",
          children: sku.name
        }), (sku == null ? void 0 : sku.price) && /* @__PURE__ */ jsx("span", {
          className: "price",
          children: sku.price
        }), (sku == null ? void 0 : sku.listPrice) && /* @__PURE__ */ jsx("span", {
          className: "list_price",
          children: sku.listPrice
        }), (sku == null ? void 0 : sku.url) && /* @__PURE__ */ jsx("span", {
          className: "url",
          children: sku.url.toString()
        }), (sku == null ? void 0 : sku.imageUrl) && /* @__PURE__ */ jsx("span", {
          className: "image_url",
          children: sku.imageUrl.toString()
        }), (sku == null ? void 0 : sku.gtin) && /* @__PURE__ */ jsx("span", {
          className: "gtin",
          children: sku.gtin
        }), (sku == null ? void 0 : sku.availability) && /* @__PURE__ */ jsx("span", {
          className: "availability",
          children: sku.availability
        }), (sku == null ? void 0 : sku.customFields) && Object.keys(sku.customFields).map((field, index2) => sku.customFields && sku.customFields[field] && /* @__PURE__ */ jsx("span", {
          className: field,
          children: sku.customFields[field]
        }, index2))]
      }, index))]
    })]
  });
}
function NostoCategory(props) {
  const {
    category
  } = props;
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("home");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewCategory(category).setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, category, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "category"
    }), /* @__PURE__ */ jsx("div", {
      className: "nosto_category",
      style: {
        display: "none"
      },
      children: category
    })]
  });
}
function NostoSearch(props) {
  const {
    query
  } = props;
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("search");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewSearch(query).setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, query, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "search"
    }), /* @__PURE__ */ jsx("div", {
      className: "nosto_search",
      style: {
        display: "none"
      },
      children: query
    })]
  });
}
function snakeize(obj) {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  if (isDate(obj) || isRegex(obj)) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(snakeize);
  }
  return Object.keys(obj).reduce((acc, key) => {
    var camel = key[0].toLowerCase() + key.slice(1).replace(/([A-Z]+)/g, (_, x) => {
      return "_" + x.toLowerCase();
    });
    acc[camel] = snakeize(obj[key]);
    return acc;
  }, {});
}
function isDate(obj) {
  return Object.prototype.toString.call(obj) === "[object Date]";
}
function isRegex(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
}
function NostoOrder(props) {
  const {
    order
  } = props;
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("order");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).addOrder(snakeize(order)).setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "order"
    }), /* @__PURE__ */ jsx("div", {
      className: "nosto_order",
      style: {
        display: "none"
      },
      children: order.purchase.number
    })]
  });
}
function NostoHome(props) {
  const {
    clientScriptLoaded,
    currentVariation,
    responseMode,
    recommendationComponent,
    useRenderCampaigns
  } = useNostoContext();
  const {
    renderCampaigns,
    pageTypeUpdated
  } = useRenderCampaigns("home");
  useEffect(() => {
    if (clientScriptLoaded && pageTypeUpdated) {
      window.nostojs((api) => {
        api.defaultSession().setVariation(currentVariation).setResponseMode(responseMode).viewFrontPage().setPlacements(props.placements || api.placements.getPlacements()).load().then((data) => {
          renderCampaigns(data, api);
        });
      });
    }
  }, [clientScriptLoaded, currentVariation, recommendationComponent, pageTypeUpdated]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "nosto_page_type",
      style: {
        display: "none"
      },
      children: "front"
    })
  });
}
function NostoPlacement(props) {
  const {
    id,
    pageType
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: "nosto_element",
    id
  }, id + (pageType || ""));
}
function NostoProvider(props) {
  let {
    account,
    currentVariation = "",
    multiCurrency = false,
    host,
    children,
    recommendationComponent,
    shopifyMarkets
  } = props;
  const [clientScriptLoadedState, setClientScriptLoadedState] = React.useState(false);
  const clientScriptLoaded = React.useMemo(() => clientScriptLoadedState, [clientScriptLoadedState]);
  currentVariation = multiCurrency ? currentVariation : "";
  const responseMode = isValidElement(recommendationComponent) ? "JSON_ORIGINAL" : "HTML";
  function RecommendationComponentWrapper(props2) {
    return React.cloneElement(recommendationComponent, {
      nostoRecommendation: props2.nostoRecommendation
    });
  }
  const [pageType, setPageType] = useState("");
  const useRenderCampaigns = function(type = "") {
    const placementRefs = useRef({});
    useEffect(() => {
      if (pageType != type) {
        setPageType(type);
      }
    }, []);
    const pageTypeUpdated = type == pageType;
    function renderCampaigns(data, api) {
      if (responseMode == "HTML") {
        api.placements.injectCampaigns(data.recommendations);
      } else {
        const recommendations = data.campaigns.recommendations;
        for (const key in recommendations) {
          let recommendation = recommendations[key];
          let placementSelector = "#" + key;
          let placement = () => document.querySelector(placementSelector);
          if (!!placement()) {
            if (!placementRefs.current[key])
              placementRefs.current[key] = createRoot(placement());
            const root = placementRefs.current[key];
            root.render(/* @__PURE__ */ jsx(RecommendationComponentWrapper, {
              nostoRecommendation: recommendation
            }));
          }
        }
      }
    }
    return {
      renderCampaigns,
      pageTypeUpdated
    };
  };
  useEffect(() => {
    var _a, _b, _c;
    if (!window.nostojs) {
      window.nostojs = (cb) => {
        (window.nostojs.q = window.nostojs.q || []).push(cb);
      };
      window.nostojs((api) => api.setAutoLoad(false));
    }
    if (!document.querySelectorAll("[nosto-client-script]").length && !shopifyMarkets) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//" + (host || "connect.nosto.com") + "/include/" + account;
      script.async = true;
      script.setAttribute("nosto-client-script", "");
      script.onload = () => {
        var _a2;
        if (typeof jest !== "undefined") {
          (_a2 = window.nosto) == null ? void 0 : _a2.reload({
            site: "localhost"
          });
        }
        setClientScriptLoadedState(true);
      };
      document.body.appendChild(script);
    }
    if (!!shopifyMarkets) {
      const existingScript = document.querySelector("[nosto-client-script]");
      const nostoSandbox = document.querySelector("#nosto-sandbox");
      if (!existingScript || (existingScript == null ? void 0 : existingScript.getAttribute("nosto-language")) != (shopifyMarkets == null ? void 0 : shopifyMarkets.language) || (existingScript == null ? void 0 : existingScript.getAttribute("nosto-market-id")) != (shopifyMarkets == null ? void 0 : shopifyMarkets.marketId)) {
        if (clientScriptLoadedState) {
          setClientScriptLoadedState(false);
        }
        (_a = existingScript == null ? void 0 : existingScript.parentNode) == null ? void 0 : _a.removeChild(existingScript);
        (_b = nostoSandbox == null ? void 0 : nostoSandbox.parentNode) == null ? void 0 : _b.removeChild(nostoSandbox);
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "//" + (host || "connect.nosto.com") + `/script/shopify/market/nosto.js?merchant=${account}&market=${shopifyMarkets.marketId || ""}&locale=${((_c = shopifyMarkets == null ? void 0 : shopifyMarkets.language) == null ? void 0 : _c.toLowerCase()) || ""}`;
        script.async = true;
        script.setAttribute("nosto-client-script", "");
        script.setAttribute("nosto-language", (shopifyMarkets == null ? void 0 : shopifyMarkets.language) || "");
        script.setAttribute("nosto-market-id", String(shopifyMarkets == null ? void 0 : shopifyMarkets.marketId));
        script.onload = () => {
          var _a2;
          if (typeof jest !== "undefined") {
            (_a2 = window.nosto) == null ? void 0 : _a2.reload({
              site: "localhost"
            });
          }
          setClientScriptLoadedState(true);
        };
        document.body.appendChild(script);
      }
    }
  }, [clientScriptLoadedState, shopifyMarkets]);
  return /* @__PURE__ */ jsx(NostoContext.Provider, {
    value: {
      account,
      clientScriptLoaded,
      currentVariation,
      responseMode,
      recommendationComponent,
      useRenderCampaigns,
      pageType
    },
    children
  });
}
function NostoSession(props) {
  const {
    cart,
    customer
  } = props;
  const {
    clientScriptLoaded
  } = useNostoContext();
  useDeepCompareEffect(() => {
    const currentCart = cart ? snakeize(cart) : void 0;
    const currentCustomer = customer ? snakeize(customer) : void 0;
    if (clientScriptLoaded) {
      window.nostojs((api) => {
        api.defaultSession().setResponseMode("HTML").setCart(currentCart).setCustomer(currentCustomer).viewOther().load();
      });
    }
  }, [clientScriptLoaded, cart, customer]);
  return /* @__PURE__ */ jsx(Fragment, {});
}
export { Nosto404, NostoCategory, NostoCheckout, NostoContext, NostoHome, NostoOrder, NostoOther, NostoPlacement, NostoProduct, NostoProvider, NostoSearch, NostoSession, useNostoContext };
